import React, {memo} from "react";
import PropTypes from "prop-types";
import {useCalculateFontSize} from "./useCalculateFontSize";

/** This component will be used in plot components to display stat value
 * This calculates font size of text based on container size and text length
 * This component takes size of its Wrapper component, Wrapper component should have relative position
 */

const StatDisplay = (props) => {
  const {color, text} = props;

  const {containerRef, fontSize} = useCalculateFontSize(text);

  return (
    <div
      className="d-flex justify-content-center align-items-center position-absolute"
      ref={containerRef}
      style={{
        inset: 0,
        pointerEvents: "none",
      }}
    >
      <p
        className="roboto"
        style={{
          fontSize: `${fontSize}px`,
          fontWeight: 100,
          color,
        }}
      >
        {text}
      </p>
    </div>
  );
};

StatDisplay.propTypes = {
  /** Color of text */
  color: PropTypes.string.isRequired,
  /** Text to be displayed */
  text: PropTypes.string.isRequired,
};

export default memo(StatDisplay);
